import { component } from "picoapp";
import { openStoreLocatorModal } from "./store-locator-modal";

export const storeLocatorButton = component((node) => {
  const upcCode = node.dataset.productLocatorUpc;
  if (!upcCode) return;
  const button = node.querySelector<HTMLButtonElement>("button");
  if (!button) return;

  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
    openStoreLocatorModal(upcCode);
  };

  button.addEventListener("click", handleClick);

  return () => {
    button.removeEventListener("click", handleClick);
  };
});
